<template>
  <el-dialog
    ref="dialog"
    title="大包详情"
    :visible.sync="visible"
    width="400px"
    :close-on-click-modal="false"
    @close="close"
  >
    <div class="content" ref="content">
      <p>LP单号：{{ detailInfo.handoverContentCode || "--" }}</p>
      <p>运单号：{{ detailInfo.handoverOrderId || "--" }}</p>
      <p>预估重量（kg）：{{ detailInfo.weight || 0 }} kg</p>
      <p>申报件数：{{ detailInfo.quantity || 0 }}件</p>
    </div>

    <div class="btnBox">
      <el-button type="text" @click="print" :disabled="!detailInfo.sellerId"
        >打印（{{ detailInfo.printCount || 0 }}）</el-button
      >
    </div>
  </el-dialog>
</template>
<script>
import { ajaxPost, Baseurl } from "@/api/api/api";
export default {
  name: "bigPackageDetail",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    currentForm: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      detailInfo: {},
    };
  },
  mounted() {
    if (this.currentForm.id) {
      this.getDetail();
    }
  },
  methods: {
    getDetail() {
      const API = Baseurl + "aliexpressParcel/selectHandoverDetails";
      const sendData = { id: this.currentForm.id };
      const loading = this.$loading({
        target: this.$refs.content,
        text: "努力加载中...",
        background: "rgba(218,218,238,0.2)",
      });
      ajaxPost(API, sendData).then((res) => {
        const { code, data } = res.data;
        if (code === 200) {
          this.detailInfo = data || {};
        } else {
          this.$message.error(data);
        }
        loading.close();
      });
    },
    print() {
      if (this.detailInfo.url) {
        window.open(this.detailInfo.url, "_blank");
        this.updatePrimtNum();
      } else {
        const API = Baseurl + "aliexpressParcel/getHandoverPdf";
        const sendData = {
          sellerId: this.detailInfo.sellerId,
          handoverContentId: this.detailInfo.handoverContentId,
        };
        ajaxPost(API, sendData).then((res) => {
          const { code, data } = res.data;
          if (code === 200) {
            window.open(data, "_blank");
            this.updatePrimtNum();
          } else {
            this.$message.error(data);
          }
        });
      }
    },
    //更新打印次数
    updatePrimtNum() {
      const API = Baseurl + "aliexpressParcel/updateHandoverPrintCount";
      const sendData = {
        id: this.currentForm.id,
      };
      ajaxPost(API, sendData).then((res) => {
        if (res.data.code === 200) {
          this.getDetail();
        }
      });
    },

    close() {
      this.$emit("cancelVisible");
    },
  },
};
</script>
<style lang="scss" scoped>
p {
  line-height: 32px;
}

.btnBox {
  display: flex;
  justify-content: flex-end;
}
</style>
